// mediaCap.ts — the media HEIGHT BUDGET, the single source of truth for media sizing.
//
// Why a height cap rather than an aspect-ratio rule: the feed's centre column is fluid
// (ShellLayout uses `minmax(0, 1fr)` with no max-width), so it is ~640px at 1280 and
// ~1280px at 1920. A pure aspect rule therefore does NOT bound height — a 16:9 image in a
// 1280px column is still 720px tall. Capping HEIGHT and deriving width from it is what
// actually bounds the card.
//
// ⚠ THE DOUBLE DECLARATION IS DELIBERATE — DO NOT "TIDY" IT.
// The `vh` line must come FIRST and the `svh` line second. An engine without `svh` support
// drops only the second declaration and keeps the fallback; if the fallback were missing or
// ordered last, the whole custom property would be absent, the cap would silently vanish and
// the runaway-height bug would return — in production only.

import { css } from 'styled-components';
import { media } from '@/theme/media';

/** Feed cap. ~460px keeps a post's card at ~688px, so the next post stays on screen. */
export const mediaCap = css`
  --media-cap: min(58vh, 460px);
  --media-cap: min(58svh, 460px);
  ${media.mobile`
    --media-cap: min(62vh, 440px);
    --media-cap: min(62svh, 440px);
  `}
`;

/** Post detail is a destination, not a scanning surface, so it gets a bigger budget. */
export const mediaCapHero = css`
  --media-cap: min(72vh, 640px);
  --media-cap: min(72svh, 640px);
  ${media.mobile`
    --media-cap: min(68vh, 520px);
    --media-cap: min(68svh, 520px);
  `}
`;
